import { Coins } from 'lucide-react';

import { useAuth, useChatMessages } from '@chainlit/react-client';

import { apiClient, type TokenUsageTotals } from '@/api';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';

import { useFetch } from '@/hooks/useFetch';
import { formatTokenCount } from '@/lib/format';

const REFRESH_INTERVAL_MS = 10_000;

export default function ThreadTokenUsage() {
  const { user } = useAuth();
  const { threadId } = useChatMessages();
  const url = threadId
    ? apiClient.buildEndpoint(
        `/user/threads/${encodeURIComponent(threadId)}/token-usage`
      )
    : null;
  const { data, error } = useFetch(url, {
    refreshInterval: REFRESH_INTERVAL_MS
  });
  const usage = data as TokenUsageTotals | undefined;

  // Demo (temporary) accounts must not see raw token counts (#1054).
  if (user?.metadata?.temp_account) return null;
  if (!threadId || error || usage?.total_tokens == null) return null;

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="flex items-center gap-1 rounded-md px-2 py-1 text-xs text-muted-foreground font-mono tabular-nums">
            <Coins className="h-3 w-3" />
            {formatTokenCount(usage.total_tokens)}
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          Tokens used in this thread · in{' '}
          {formatTokenCount(usage.input_tokens)} / out{' '}
          {formatTokenCount(usage.output_tokens)}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
